import { Loader } from './ui/Loader';
export { CircularProgress as CircularLoader } from '@mui/material';
export { LinearProgress } from './ui/LinearProgress';
export default Loader;
